import { tenantConf } from "../../../../conf";
export default `__('Anmeldung') | ${tenantConf?.BrandName}`